import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// pages
import { LoginPageComponent } from '../../../pages/login/login.component';

// services
import { UnauthGuard } from '../../../services/unauthGuard';
import { LoginModule } from './login.module';

const routes: Routes = [
  {
    path: '',
    component: LoginPageComponent,
    canActivate: [UnauthGuard],
    data: { authentication: true },
  },
];

export const routing: ModuleWithProviders<LoginModule> =
  RouterModule.forChild(routes);
